exports.linkResolver = (doc) => {
  // URL for a blog post
  if (doc.type === "blog_post") {
    return `/wissen/${doc.uid}`;
  }

  // URL for a press article
  if (doc.type === "press_article") {
    return `/presse/${doc.uid}`;
  }

  // URL for a company
  if (doc.type === "company") {
    return `/unsere-betriebe/${doc.uid}`;
  }

  // URL for a page type
  if (doc.type === "page" && doc.uid !== "home") {
    return `/${doc.uid}`;
  }

  // Backup for all other types
  return "/";
};
